import { Component, ElementRef, Inject, ViewChild, WritableSignal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { FormControl } from '@angular/forms';
import { Observable, Subject, debounceTime, filter, map, startWith, switchMap } from 'rxjs';
import { Group } from '../../../models/group';
import { BulkGroupChooserComponent } from '../../bulk-group-chooser/bulk-group-chooser.component';
import { GroupsService } from '../../../services/groups.service';
import { Effort } from '../../../models/effort';

@Component({
  selector: 'app-groups-picker-dialog',
  standalone: true,
  templateUrl: './groups-picker-dialog.component.html',
  styleUrls: ['./groups-picker-dialog.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatSelectModule,
    BulkGroupChooserComponent
],
})
export class GroupsPickerDialogComponent {
  @ViewChild('userFilterInput', {static: false}) input!: ElementRef<HTMLInputElement>;
  title: string = "Add groups to effort ";
  effort!: WritableSignal<Effort>;

  tagControl = new FormControl('');
  groupFilter = new FormControl('');
  membershipType = new FormControl('');
  filteredTags$: Observable<string[]>;
  userDataSource = new MatTableDataSource<Group>([]);
  selectedGroups: Group[] = [];
  chosenGroups: Group[] = [];
  allTags: string[] = ['Admin', 'Finance', 'HR', 'IT', 'Root']; // Example tag list
  displayedColumns: string[] = ['name', 'association', 'tools'];
  _options = new Subject<Group[]>();
  options = this._options.asObservable();
  _filter = new Subject<string>();
  filter = this._filter.asObservable();
  constructor(
    public dialogRef: MatDialogRef<GroupsPickerDialogComponent>,
    private groupService: GroupsService,
    @Inject(MAT_DIALOG_DATA) public data: { title: string }
  ) {
    this.title = data.title ?? "Please choose one or more groups";
    this.filteredTags$ = this.tagControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filterTags(value || ''))
    );
    this.filter.pipe(
      filter(c => c != null),
      debounceTime(100),
      switchMap(c => this.groupService.filterGroups([ { chip: null, value: c.trim() }], 5))
    ).subscribe(res => this._options.next(res.groups));
  }

  private _filterTags(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter((tag) =>
      tag.toLowerCase().includes(filterValue)
    );
  }

  groupsChange(groups: Group[]) {
    this.chosenGroups = groups;
    console.log(arguments, this.groupFilter.value);
  }

  cancel() {
    this.dialogRef.close();
  }

  addGroups() {
    console.log(this.chosenGroups);
    this.dialogRef.close(this.chosenGroups);
  }
}
